import { Column } from "@gadgetinc/widgets";
import type { TurnstileInstance } from "@marsidev/react-turnstile";
import { Turnstile } from "@marsidev/react-turnstile";
import { observer } from "mobx-react-lite";
import React, { type RefObject } from "react";
import { useGadgetAuthConfig } from "./AuthLayout";

export type CloudflareTurnstileProtectedForm = {
  showTurnstile: boolean;
  cfTurnstileRef: RefObject<TurnstileInstance | undefined>;
  setCfTurnstileToken: (cfTurnstileToken: string) => void;
  setCfTurnstileRequiresInteraction: (cfTurnstileRequiresInteraction: boolean) => void;
};

export const CloudflareTurnstile = observer((props: { protectedEntity: CloudflareTurnstileProtectedForm }) => {
  const { protectedEntity } = props;

  const config = useGadgetAuthConfig();

  return (
    <>
      {!config.bypassCfTurnstile && (
        <Column $style={{ display: protectedEntity.showTurnstile ? "flex" : "none", flex: 1, alignItems: "center" }}>
          <Turnstile
            ref={protectedEntity.cfTurnstileRef}
            options={{
              theme: "light",
            }}
            siteKey={config.cfTurnstileSiteKey}
            onSuccess={(token) => {
              protectedEntity.setCfTurnstileToken(token);
              protectedEntity.setCfTurnstileRequiresInteraction(false);
            }}
            onBeforeInteractive={() => {
              protectedEntity.setCfTurnstileRequiresInteraction(true);
            }}
          />
        </Column>
      )}
    </>
  );
});
